import React from 'react'

const Manual_activacion_de_caja_para_pedidos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     DELIVERECT - Activación de Caja para Pedidos
     </h2>
     <iframe
          src="https://scribehow.com/embed/DELIVERECT__Activacion_de_Caja_para_Pedidos__T_7eCXZZRpeIFnH_T33tZg?as=scrollable"
          className="scribe-iframe-deliverect-4"
          width="100%"
          height="3800"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_activacion_de_caja_para_pedidos